<template>
  <section class="neighborhood-scores grid grid-cols-2 md-grid-cols-4" :class="{ empty: !cards || cards.length === 0 }">
    <mvtFactCard v-for="(card, i) in cards" :key="i"
        :icon="card.icon"
        :subtitle="card.title"
        :info="card.info"
    >
      <span class="f2">{{ card.score }}</span>
    </mvtFactCard>
  </section>
</template>

<script>

import mvtFactCard from '@/common/components/mvtfactcard/mvt-factcard.vue';

export default {
  name: 'neighborhoodScores',
  components: {
    mvtFactCard,
  },
  props: {
    scores: Object,
  },
  computed: {
    cards() {
      return this.scores ? [
        {
          title: 'Walking',
          score: this.scores.walk,
          icon: 'walking',
          info: 'Measures the location\'s friendliness to pedestrians based on its proximity to nearby places of interest. Based on a scale of 1-100.'
        },
        {
          title: 'Kids',
          score: this.scores.kid,
          icon: 'smile',
          info: 'Measures the % of households with children in the area. Based on a scale of 58-100.',
        },
        {
          title: 'Food',
          score: this.scores.food,
          icon: 'poi-eat',
          info: 'Measures the variety of restaurants within a short driving distance. Based on a scale of 1-100.'
        },
        {
          title: 'Pets',
          score: this.scores.pet,
          icon: 'dog',
          info: 'Measures the availability of nearby pet stores, veterinarians, and other pet-focused service providers. Based on a scale of 58-100.'
        },
      ] : [];
    }
  },
};


</script>

<style>
  @use "~@/common/scss/base/_defined.scss" as *;

  .neighborhood-scores {
    margin-top: 3rem;
    @media screen and (min-width: $screen-md-min) {
      min-height: 4rem;
      position: relative;
      margin-top: -1.5rem;
      z-index: 100;
    }
    &.empty {
      margin: 1rem;
    }
  }

  .title {
      margin-top: 5rem;
      margin-bottom: 0;
    @media screen and (min-width: $screen-md-min) {
      margin: 2rem 0;
    }
  }
</style>